import React from 'react'
import { useTranslation } from 'react-i18next'
import Part from '../../../components/HomePart'
import img from '../../../assets/img/roadmap.svg'
import imgM from '../../../assets/img/roadmap-m.svg'
import './style.scss'
import System from '../../../store/system'

const Roadmap: React.FC = () => {
  const { t } = useTranslation('trans', { keyPrefix: 'roadmap' })
  const { isMobile } = System.useContainer()

  return (
    <Part id="roadmap" title={t('title')}>
      <div className="description">
        <img src={isMobile ? imgM : img} alt="" />
      </div>
    </Part>
  )
}

export default Roadmap
